Object.defineProperty(exports, "__esModule", { value: true })
exports.routes = void 0
var react_1 = require("react")
var links_1 = require("./links")
exports.routes = [
  {
    path: links_1.links.home.dashboard(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/home/Dashboard")
      })
    }),
    exact: true,
  },
  {
    path: links_1.links.report.report(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/report/Report")
      })
    }),
    exact: true,
  },
  {
    path: links_1.links.report.monitoring(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/report/pages/Monitoring/Monitoring")
      })
    }),
  },
  {
    path: links_1.links.report.project(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/report/pages/Approve/Approve")
      })
    }),
  },
  {
    path: links_1.links.report.statistics(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/report/pages/Statistics/Statistics")
      })
    }),
  },
  {
    path: links_1.links.report.reflectionReportProcessingUnit(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/report/pages/ProcessingUnit")
      })
    }),
  },
  {
    path: links_1.links.report.reflectionReportVote(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/report/pages/Evaluate")
      })
    }),
  },
  {
    path: links_1.links.report.reflectionReportReflectionField(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/report/pages/ReflectionField")
      })
    }),
  },
  {
    path: links_1.links.report.reflectionReportCategory(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/report/pages/Category")
      })
    }),
  },
  {
    path: links_1.links.report.reflectionReportSource(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/report/pages/Source")
      })
    }),
  },
  {
    path: links_1.links.report.reflectionReportProcessingDate(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/report/pages/ProcessingDate")
      })
    }),
  },
  {
    path: links_1.links.oneportal.changePassword(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/oneportal/pages/ChangePassword/ChangePassword")
      })
    }),
  },
  {
    path: links_1.links.oneportal.profile(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/oneportal/pages/Profile/Profile")
      })
    }),
  },
  {
    path: links_1.links.records.addRecord(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/records/pages/CreateOrEditRecordForm/CreateOrUpdateRecordForm")
      })
    }),
  },
  {
    path: links_1.links.records.editRecord(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/records/pages/CreateOrEditRecordForm/CreateOrUpdateRecordForm")
      })
    }),
  },
  {
    path: links_1.links.records.records(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/records/pages/ListRecord/ListRecord")
      })
    }),
  },
  {
    path: links_1.links.records.projects(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/records/pages/ListProject/ListProject")
      })
    }),
  },
  {
    path: links_1.links.system.listUser(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/system/pages/ListUser")
      })
    }),
  },
  {
    path: links_1.links.system.listRole(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/system/pages/ListRole")
      })
    }),
  },
  {
    path: links_1.links.system.listLog(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/system/pages/ListLog")
      })
    }),
  },
  {
    path: links_1.links.category.categoryManagement(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/category/pages/ListCategory")
      })
    }),
  },
  {
    path: links_1.links.category.reflectionFieldsManagement(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/category/pages/ListReflectionField")
      })
    }),
  },
  {
    path: links_1.links.category.reflectionProcessingUnit(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/category/pages/ListReflectionProcessingUnit")
      })
    }),
  },
  {
    path: links_1.links.category.reflectionSource(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/category/pages/ListReflectionSource")
      })
    }),
  },
  {
    path: links_1.links.category.distrists(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/category/pages/ListDistrict")
      })
    }),
  },
  {
    path: links_1.links.category.communes(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/category/pages/ListCommune")
      })
    }),
  },
  {
    path: links_1.links.reflect.reflectionWaitingReceive(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/reflect/pages/WaitingReceive")
      })
    }),
  },
  {
    path: links_1.links.reflect.reflectionWaitingProcess(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/reflect/pages/WaitingProcess")
      })
    }),
  },
  {
    path: links_1.links.reflect.reflectionHaveComment(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/reflect/pages/HaveComment")
      })
    }),
  },
  {
    path: links_1.links.reflect.reflectionHaveDiscuss(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/reflect/pages/HaveDiscuss")
      })
    }),
  },
  {
    path: links_1.links.reflect.reflectionWaitingApprove(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/reflect/pages/WaitingApprove")
      })
    }),
  },
  {
    path: links_1.links.reflect.reflectionHaveProcessed(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/reflect/pages/HaveProcessed")
      })
    }),
  },
  {
    path: links_1.links.reflect.reflectionComplete(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/reflect/pages/Complete")
      })
    }),
  },
  {
    path: links_1.links.reflect.reflectionMap(),
    component: (0, react_1.lazy)(function () {
      return Promise.resolve().then(function () {
        return require("../modules/reflect/pages/Map")
      })
    }),
  },
]
//# sourceMappingURL=routes.js.map
